import React from "react";
import "./styles.css";
import axios from "axios";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";

const emptyForm = { from: "", to: "", extraPrice: "" };

export default class Taxe extends React.Component {
  state = {
    extraPriceRanges: [],
    extraPriceRangesLoading: true,
    dialogOpen: false,
    editingId: null,
    form: emptyForm,
    dialogSaving: false,
    deletingId: null,
  };

  componentDidMount() {
    this.loadExtraPriceRanges();
  }

  loadExtraPriceRanges = async () => {
    this.setState({ extraPriceRangesLoading: true });
    try {
      const token = localStorage.getItem("access_token");
      const response = await axios.get("https://api.appetito.ro/v1/admin/extra-price-ranges", {
        headers: { Authorization: `Bearer ${token}` },
      });
      this.setState({ extraPriceRanges: response.data || [] });
    } catch (e) {
      alert("Eroare la încărcarea taxelor suplimentare pe distanță.");
    } finally {
      this.setState({ extraPriceRangesLoading: false });
    }
  };

  openCreateDialog = () => {
    this.setState({ dialogOpen: true, editingId: null, form: emptyForm });
  };

  openEditDialog = (range) => {
    this.setState({
      dialogOpen: true,
      editingId: range.id,
      form: { from: range.from, to: range.to, extraPrice: range.extraPrice },
    });
  };

  closeDialog = () => {
    this.setState({ dialogOpen: false, editingId: null, form: emptyForm });
  };

  updateFormField = (field) => (event) => {
    this.setState({ form: { ...this.state.form, [field]: event.target.value } });
  };

  saveExtraPriceRange = async () => {
    const { editingId, form } = this.state;
    const payload = {
      from: parseFloat(form.from),
      to: parseFloat(form.to),
      extraPrice: parseFloat(form.extraPrice),
    };

    if (Number.isNaN(payload.from) || Number.isNaN(payload.to) || Number.isNaN(payload.extraPrice)) {
      alert("Completează toate câmpurile cu valori numerice.");
      return;
    }
    if (payload.to <= payload.from) {
      alert("Valoarea de sfârșit trebuie să fie mai mare decât cea de început.");
      return;
    }

    this.setState({ dialogSaving: true });
    try {
      const token = localStorage.getItem("access_token");
      const headers = { Authorization: `Bearer ${token}` };
      if (editingId) {
        await axios.put(
          `https://api.appetito.ro/v1/admin/extra-price-ranges/${editingId}`,
          payload,
          { headers }
        );
      } else {
        await axios.post("https://api.appetito.ro/v1/admin/extra-price-ranges", payload, {
          headers,
        });
      }
      await this.loadExtraPriceRanges();
      this.closeDialog();
    } catch (e) {
      alert("Eroare la salvarea taxei suplimentare.");
    } finally {
      this.setState({ dialogSaving: false });
    }
  };

  deleteExtraPriceRange = async (range) => {
    if (!window.confirm(`Ștergi intervalul ${range.from} - ${range.to} km?`)) {
      return;
    }
    this.setState({ deletingId: range.id });
    try {
      const token = localStorage.getItem("access_token");
      await axios.delete(`https://api.appetito.ro/v1/admin/extra-price-ranges/${range.id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      await this.loadExtraPriceRanges();
    } catch (e) {
      alert("Eroare la ștergerea taxei suplimentare.");
    } finally {
      this.setState({ deletingId: null });
    }
  };

  render() {
    const {
      extraPriceRanges,
      extraPriceRangesLoading,
      dialogOpen,
      editingId,
      form,
      dialogSaving,
      deletingId,
    } = this.state;

    return (
      <div className="settings-container">
        <h2 className="settings-title">Taxe</h2>

        <div className="settings-section">
          <div className="settings-section-header">
            <h3 className="settings-section-title">Taxă suplimentară pe distanță</h3>
            <IconButton color="primary" onClick={this.openCreateDialog} title="Adaugă interval">
              <AddIcon />
            </IconButton>
          </div>
          <span className="settings-description">
            Definește intervale de distanță (km) pentru care se adaugă o taxă suplimentară la livrare.
          </span>

          {extraPriceRangesLoading ? (
            <div className="loader-container">
              <div className="loader" />
            </div>
          ) : (
            <Table size="small" style={{ marginTop: 16 }}>
              <TableHead>
                <TableRow>
                  <TableCell>De la (km)</TableCell>
                  <TableCell>Până la (km)</TableCell>
                  <TableCell>Taxă suplimentară (lei)</TableCell>
                  <TableCell align="right"></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {extraPriceRanges.map((range) => (
                  <TableRow key={range.id}>
                    <TableCell>{range.from}</TableCell>
                    <TableCell>{range.to}</TableCell>
                    <TableCell>{range.extraPrice}</TableCell>
                    <TableCell align="right">
                      <IconButton size="small" onClick={() => this.openEditDialog(range)}>
                        <EditIcon fontSize="small" />
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={() => this.deleteExtraPriceRange(range)}
                        disabled={deletingId === range.id}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
                {extraPriceRanges.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={4} style={{ textAlign: "center", color: "#888" }}>
                      Niciun interval definit.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          )}
        </div>

        <Dialog open={dialogOpen} onClose={this.closeDialog} fullWidth maxWidth="xs">
          <DialogTitle>{editingId ? "Editează interval" : "Adaugă interval"}</DialogTitle>
          <DialogContent>
            <TextField
              label="De la (km)"
              type="number"
              fullWidth
              margin="normal"
              value={form.from}
              onChange={this.updateFormField("from")}
            />
            <TextField
              label="Până la (km)"
              type="number"
              fullWidth
              margin="normal"
              value={form.to}
              onChange={this.updateFormField("to")}
            />
            <TextField
              label="Taxă suplimentară (lei)"
              type="number"
              fullWidth
              margin="normal"
              value={form.extraPrice}
              onChange={this.updateFormField("extraPrice")}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.closeDialog} disabled={dialogSaving}>
              Anulează
            </Button>
            <Button
              onClick={this.saveExtraPriceRange}
              color="primary"
              variant="contained"
              disabled={dialogSaving}
            >
              Salvează
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
